import { render, staticRenderFns } from "./facial-filter.vue?vue&type=template&id=861378f0&scoped=true&"
import script from "./facial-filter.vue?vue&type=script&lang=js&"
export * from "./facial-filter.vue?vue&type=script&lang=js&"
import style0 from "./facial-filter.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./facial-filter.vue?vue&type=style&index=1&id=861378f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861378f0",
  null
  
)

export default component.exports